
  import { ReactChart } from 'chartjs-react';
  import { Chart, registerables } from 'chart.js';
  import { useMemo, useState } from 'react';
  import TenantServices from './../../services/TenantServices';
  import { RefreshIcon } from '@heroicons/react/solid';
  import { HollowDotsSpinner } from 'react-epic-spinners';
  import { useCachedResource } from './../../utils/apiCache';
  Chart.register(...registerables);

const buildOptions = (resp) => {
    var labels = [];
    var SucccessfulUtilityData = [];
    var failedUtilityData = [];
    var successfulAirtime =[];
    var failedAirtime=[];
    var successfulData=[];
    var failedDATA=[];
    resp?.data?.map(data => {
      SucccessfulUtilityData.push(data.successSum);
      failedUtilityData.push(data.failedSum);
      failedAirtime.push(data.airtimeFailedSum);
      successfulAirtime.push(data.airtimeSuccessSum);
      successfulData.push(data.dataSuccessSum);
      failedDATA.push(data.dataFailedSum);
      labels.push(data.date);
    });
    return {
      airtimeOption: {
        labels: [...labels],
        datasets: [
          {
            label: "Successful Airtime",
            data: [...successfulAirtime],
            lineTension: 0,
            fill: false,
            borderColor: 'yellow',
            backgroundColor: 'transparent',
            pointBorderColor: 'yellow',
            pointBackgroundColor: 'yellow',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          },
        {
          label: "Failed Airtime",
          data: [...failedAirtime],
          lineTension: 0,
          fill: false,
          borderColor: 'purple',
          backgroundColor: 'transparent',
          pointBorderColor: 'purple',
          pointBackgroundColor: 'purple',
          borderDash: [15, 5],
          pointRadius: 5,
          pointHoverRadius: 10,
          pointHitRadius: 30,
          pointBorderWidth: 2,
          pointStyle: 'rectRounded'
        }
      ]
      },
      utilityOption: {
        labels: [...labels],
        datasets: [
          {
          label: "Successful Bills",
          data: [...SucccessfulUtilityData],
          lineTension: 0,
          fill: false,
          borderColor: 'green',
          backgroundColor: 'transparent',
          pointBorderColor: 'green',
          pointBackgroundColor: 'green',
          borderDash: [15, 5],
          pointRadius: 5,
          pointHoverRadius: 10,
          pointHitRadius: 30,
          pointBorderWidth: 2,
          pointStyle: 'rectRounded'
        },
        {
          label: "Failed Bills",
          data: [...failedUtilityData],
          lineTension: 0,
          fill: false,
          borderColor: 'red',
          backgroundColor: 'transparent',
          pointBorderColor: 'red',
          pointBackgroundColor: 'red',
          borderDash: [15, 5],
          pointRadius: 5,
          pointHoverRadius: 10,
          pointHitRadius: 30,
          pointBorderWidth: 2,
          pointStyle: 'rectRounded'
        },
      ]
      },
      dataOptions: {
        labels: [...labels],
        datasets: [
        {
          label: "Successful Data",
          data: [...successfulData],
          lineTension: 0,
          fill: false,
          borderColor: 'gray',
          backgroundColor: 'transparent',
          pointBorderColor: 'gray',
          pointBackgroundColor: 'gray',
          borderDash: [15, 5],
          pointRadius: 5,
          pointHoverRadius: 10,
          pointHitRadius: 30,
          pointBorderWidth: 2,
          pointStyle: 'rectRounded'
        },
        {
          label: "Failed Data",
          data: [...failedDATA],
          lineTension: 0,
          fill: false,
          borderColor: 'orange',
          backgroundColor: 'transparent',
          pointBorderColor: 'orange',
          pointBackgroundColor: 'orange',
          borderDash: [15, 5],
          pointRadius: 5,
          pointHoverRadius: 10,
          pointHitRadius: 30,
          pointBorderWidth: 2,
          pointStyle: 'rectRounded'
        }]
      }
    };
};

const baseOptions = (title) => ({
  plugins: {
    legend: {
      display: true,
      position: 'top',
      labels: {
        boxWidth: 10,
        usePointStyle: true,
        pointStyle: "line"
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      title: {
        display: true,
        text: title,
        color: "red",
        font: {
          size: 24,
          weight: "bold"
        }
      }
    },
    y: {
      grid: {
        color: "#ccc",
        borderDash: [5, 1],
        borderColor: "black",
        tickColor: "black"
      },
      title: {
        display: true,
        text: "",
        color: "green",
        font: {
          size: 18,
          weight: "bold"
        }
      }
    }
  }
});

export default function BillGraph(){
    const { data: resp, loading, refresh } = useCachedResource(
      "dashboard.bills-graph",
      () => TenantServices.billsGraph()
    );

    const built = useMemo(() => (resp ? buildOptions(resp) : {}), [resp]);
    const dataGraph = built.dataOptions || {};
    const airtimeGraph = built.airtimeOption || {};
    const utilityGraph = built.utilityOption || {};

    return (
      <div className="relative">
        <button
          type="button"
          onClick={refresh}
          className="absolute -top-6 right-0 z-10 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-600 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-100 focus:outline-none"
        >
          <RefreshIcon className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
          Refresh
        </button>
        {loading && Object.keys(built).length === 0 ? (
          <div className="flex justify-center py-10">
            <HollowDotsSpinner size={40} color="#4D627E" />
          </div>
        ) : (
          <>
            {/* Airtime graph */}
            <div className='mt-5'>
              <ReactChart
              type='line'
              options={baseOptions("Airtime Payment")}
              data={airtimeGraph}
              width ={100}/>
            </div>
            {/* Other payments */}
            <div className='mt-5'>
              <ReactChart type='line'
              options={baseOptions("Bills Payment")}
              data={utilityGraph}
              width={100} />
            </div>
            {/* Data graph */}
            <ReactChart
              type="line"
              data={dataGraph}
              options={baseOptions("Data Payment")}
              width={100}
            />
          </>
        )}
      </div>
    );
}
